import { render, staticRenderFns } from "./CphButton.vue?vue&type=template&id=78667145&"
import script from "./CphButton.vue?vue&type=script&lang=js&"
export * from "./CphButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports